import "./PageRestrictions.css";
import "../SendCreate.css";
import { createPortal } from "react-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
  useId,
  useEffect,
} from "react";
import CreateEditRestrictions from "./CreateEditRestrictions";
import EditIcon from "../../../../assets/img/EditIcon.png";
import ModalPopUp from "../../../Controls/ModalPopUp/ModalPopUp";
import { isEditable, isFocusable } from "@testing-library/user-event/dist/utils";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../../StateManagement/actions";
import APIRequest from "../../../../Services/commonAPIConsumer";
import Alert from "../../../Controls/Alerts/Alerts";
const PageRestrictions = forwardRef(function PageRestrictions(
  { DeleteData, onCancel, onSave, addNewReaders, isFromManage },
  ref
) {
  const selectedDocName = useId();
  const [actionOfAddRule, setActionOfAddRule] = useState(false);
  const modalRef = useRef();
  const docNameRef = useRef(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isPageLevelRestrictionSelected, setIsPageLevelRestrictionSelected] =
    useState(false);
  const [readerData, setReaderData] = useState(null);

  const [readers, setReaders] = useState([]);
  const [documentPageDetails, setDocumentPageDetails] = useState([]);
  const [addRule, setAddRule] = useState(false);
  const [selectionOfRestriction, setSelectionOfRestriction] = useState([]);
  const [changeSelectionOfRestriction, setChangeSelectionOfRestriction] =
    useState(null);
  const [deleteSelectionOfRestriction, setDeleteSelectionOfRestriction] =
    useState([]);
  const [documentReadersSelection, setDocumentReadersSelection] = useState([]);

  const [enableOptionsBasedOnLevelOne, setEnableOptionsBasedOnLevelOne] =
    useState(false);
  const [approvedAccessRequests, setapprovedAccessRequests] = useState([]);
  const [originalApprovedAccessRequests, setOriginalApprovedAccessRequests] = useState([]);

  const onEditUpdateReadersRef = useRef(false);
  const pageCount = useRef(0);
  const documentId = useRef(0);
  const docName = useRef("");
  const warningModal = useRef();
  const ReceipientData = useRef([]);
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const [pageLevelAccessRequests, setPageLevelAccessRequests] = useState([]);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertClass, setAlertClass] = useState("alertindex");
  const originalRestrictionsRef = useRef([]);
  if (documentPageDetails.length > 0 && docNameRef.current) {
    const doc = documentPageDetails.find(
      (doc) => doc.DocumentName === docNameRef.current.value
    );
    if (doc) {
      pageCount.current = doc.PageCount;
      docName.current = doc.DocumentName;
      documentId.current = doc.Documentid;
      ReceipientData.current = doc.RecipientList;
    }
  }

  useImperativeHandle(ref, () => {
    return {
      handleModal(
        isChecked,
        readers,
        PageCount,
        prevSavedRestrictionData,
        approvedAccessRequests,
        isTrackViews
      ) {
        setPageLevelAccessRequests(approvedAccessRequests);
        setIsPageLevelRestrictionSelected(isChecked);
        setReaders(readers);
        setDocumentPageDetails(() => {
          return [...PageCount];
        });
        setSelectionOfRestriction(prevSavedRestrictionData);
        originalRestrictionsRef.current = JSON.parse(
          JSON.stringify(prevSavedRestrictionData)
        );
        setReaderData({});
        setEnableOptionsBasedOnLevelOne(isTrackViews);
        const enrichedApprovedRequests = (approvedAccessRequests || []).flatMap(
          (request) => {
            const rows = [];
            prevSavedRestrictionData.forEach((rule) => {
              const matchedPages = request.approvedPages.filter((page) => rule.pages.includes(page));
              if (matchedPages.length > 0) {
                rows.push({ ...request, id: `${request.id || Math.random()}_${rule.id}`, originalRequestId: request.id, approvedPages: matchedPages, ruleNickname: rule.ruleNickname || "", category: rule.category || "", ruleId: rule.id, });
              }
            });
            return rows;
          }
        );
        setOriginalApprovedAccessRequests(JSON.parse(JSON.stringify(enrichedApprovedRequests)));
        setapprovedAccessRequests(enrichedApprovedRequests);
      },
    };
  });
  // const savePageRestrictions = async (payload) => {
  //   var response = await APIRequest.PUT(
  //     JSON.stringify(payload),
  //     `${process.env.REACT_APP_API +
  //     process.env.REACT_APP_API_PutPageRestrictions
  //     }` +
  //     "/" +
  //     payload.documentId
  //   );
  //   return response;
  // };

  const handleCancel = () => {
    // setDocumentReadersSelection([]);
    // setSelectionOfRestriction([]);
    //setDeleteSelectionOfRestriction([]);
    onCancel();
  };
  const handleSave = async () => {
    try {
      const hasChanges =
        JSON.stringify(originalRestrictionsRef.current) !== JSON.stringify(selectionOfRestriction) || (deleteSelectionOfRestriction?.length ?? 0) > 0;
      onSave(selectionOfRestriction, deleteSelectionOfRestriction, approvedAccessRequests, hasChanges);
    } catch (err) {
      console.error("Error saving page restrictions:", err);
    }
  };

  const handleAddNewReaders = (addedReaders) => {
    setReaders((prev) => {
      const merged = [...prev];
      (addedReaders || []).forEach((reader) => {
        if (!merged.includes(reader)) merged.push(reader);
      });
      return merged;
    });
    if (addNewReaders) addNewReaders(addedReaders);
  };

  const onAddRuleHandler = () => {
    setAddRule(true);
    setChangeSelectionOfRestriction(null);
    setIsEdit(false);
  };

  const cancelRestrictions = () => {
    setAddRule(false);
  };
  useEffect(() => {
    setDeleteSelectionOfRestriction(DeleteData);
  }, [DeleteData]);

  useEffect(() => {
    if (readerData) {
      if (readerData.fileName) docNameRef.current.value = readerData?.fileName;
      const records = selectionOfRestriction.filter(
        (record) => record.fileName === docNameRef.current.value
      );
      setDocumentReadersSelection(() => {
        return records;
      });
      const doc = documentPageDetails.find(
        (doc) => doc.DocumentName === docNameRef.current.value
      );
      const pagesCount = [
        ...selectionOfRestriction
          .map((record) => {
            return [...record.pages];
          })
          .flat(),
      ];
      if (doc && pagesCount.length !== doc.PageCount) {
        setActionOfAddRule(false);
      } else {
        setActionOfAddRule(true);
      }
    }
  }, [readerData]);
  useEffect(() => {
    if (!originalApprovedAccessRequests.length) return;
    const updatedRequests = originalApprovedAccessRequests.map((request) => {
      const matchedRule = selectionOfRestriction.find((rule) => rule.id === request.ruleId);
      if (matchedRule) {
        const approvedPages = request.approvedPages.filter((page) => matchedRule.pages.includes(page));
        return {
          ...request,
          approvedPages,
          ruleNickname: matchedRule.ruleNickname || "",
          category: matchedRule.category || "",
        };
      }
      return null;
    }).filter((request) => request !== null && request.approvedPages.length > 0);
    setapprovedAccessRequests(updatedRequests);
  }, [selectionOfRestriction, originalApprovedAccessRequests]);

  const saveRestrictions = (restrictionData, readerList) => {
    console.log(restrictionData);

    onConfirmToSave();

    function onConfirmToSave() {
      setAddRule(false);
      setReaderData(restrictionData);
      setSelectionOfRestriction((prev) => {
        const records = prev.filter(
          (record) => record.fileName === restrictionData.fileName
        );
        if (records && records.length > 0) {
          const existingRecord = records.find(
            (x) => x.id === restrictionData.id
          );
          if (existingRecord) {
            return prev.map((record) =>
              record.fileName === restrictionData.fileName &&
                record.id === restrictionData.id
                ? {
                  ...record,
                  pages: [...restrictionData.pages],
                  category: restrictionData.category,
                  readers: restrictionData.readers,
                  isEdits: restrictionData.isEdits,
                  ruleNickname: restrictionData.ruleNickname,
                  allowAccessRequest: restrictionData.allowAccessRequest
                }
                : record
            );
          } else {
            return [...prev, { ...restrictionData }];
          }
        } else {
          return [...prev, { ...restrictionData }];
        }
      });

      setReaders(readerList);
      if (documentPageDetails.length > 0) {
        const doc = documentPageDetails.find(
          (doc) => doc.DocumentName === restrictionData.fileName
        );
        const configuredRestrictionsPages = [
          ...selectionOfRestriction
            .map((record) => {
              return [...record.pages];
            })
            .flat(),
          ...restrictionData.pages,
        ];
        if (doc && doc.PageCount === configuredRestrictionsPages.length) {
          setActionOfAddRule(true);
        }
      }
    }
  };

  const onEditHandler = (e) => {
    setIsEdit(true);
    console.log(e.target.id);
    setAddRule(true);

    const currentRowDetails = e.target.id;
    console.log(currentRowDetails);
    console.log(selectionOfRestriction);
    const rowDetails = selectionOfRestriction.filter((record) => {
      if (record.id == currentRowDetails) {
        return { ...record };
      }
    });
    console.log(rowDetails[0]);
    let id = rowDetails[0].id;
    const rowIndexDetails = rowDetails[0];
    if (rowIndexDetails) {
      const users = rowIndexDetails.readers;

      onEditUpdateReadersRef.current = readers.filter(
        (reader) => !users.includes(reader)
      );
      // setReaders((prev) => {
      //   return prev.filter((reader) => !users.includes(reader));
      // });
      setChangeSelectionOfRestriction(() => {
        return {
          id,
          category: rowIndexDetails.category,
          readers: [...rowIndexDetails.readers],
          pages: [...rowIndexDetails.pages],
          isEdits: true,
          ruleNickname: rowIndexDetails.ruleNickname,
          allowAccessRequest: rowIndexDetails.allowAccessRequest
        };
      });
    }
  };

  const onDeleteHandler = (e) => {
    console.log(e.target.id);
    const currentRowDetails = e.target.id;
    const hasMatchingAccessRequest = isAccessRequestExist(currentRowDetails);
    let msg = hasMatchingAccessRequest ? selectedLanguage.LstLanguageCodes.UI_RemoveRuleConfirmationWithAccessRequests : selectedLanguage.LstLanguageCodes.UI_DeleteRuleConfirmation;
    warningModal.current.open(msg, () => { confirmDelete(currentRowDetails) }, () => { });
  };

  function isAccessRequestExist(currentRowDetails) {
    const ruleToDelete = selectionOfRestriction.find((x) => x.id === currentRowDetails && x.fileName === docNameRef.current.value);
    const hasMatchingAccessRequest = ruleToDelete && pageLevelAccessRequests?.some((request) =>
      request.documentId === ruleToDelete.documentId &&
      request.requestedPages?.some((page) => ruleToDelete.pages?.includes(page))
    );
    return hasMatchingAccessRequest;
  }

  const confirmDelete = (id) => {
    // let id = currentRowDetails;
    setSelectionOfRestriction((prev) => {
      const existingRecord = prev.find(
        (x) => x.id == id && x.fileName === docNameRef.current.value
      );

      if (existingRecord) {
        return prev.filter(
          (x) => !(x.id == id && x.fileName === docNameRef.current.value)
        );
      }
      // return prev;
    });

    setReaderData({});
    if (DeleteData) {
      setDeleteSelectionOfRestriction((prevIds) => [...prevIds, id]);
    }
  };

  let selectedPages = [];
  let pagesToBeDisabledAnotherRestrictions = [];
  if (!changeSelectionOfRestriction && docNameRef.current) {
    const records = selectionOfRestriction.filter(
      (record) => record.fileName === docNameRef.current.value
    );
    selectedPages = records.reduce((acc, record) => {
      return acc.concat(record.pages);
    }, []);
  } else {
    selectedPages = changeSelectionOfRestriction?.pages;
    if (docNameRef.current) {
      const records = selectionOfRestriction.filter(
        (record) =>
          record.fileName === docNameRef.current.value &&
          record.id !== changeSelectionOfRestriction?.id
      );
      pagesToBeDisabledAnotherRestrictions = records.reduce((acc, record) => {
        return acc.concat(record.pages);
      }, []);
    }
  }

  const onChangeDocNameHandler = () => {
    console.log(docNameRef.current.value);
    const records = selectionOfRestriction.filter(
      (record) => record.fileName === docNameRef.current.value
    );
    setDocumentReadersSelection(() => {
      return [...records];
    });
    if (documentPageDetails.length > 0) {
      const doc = documentPageDetails.find(
        (doc) => doc.documentName === docNameRef.current.value
      );
      if (doc) pageCount.current = doc.PageCount;
      if (documentPageDetails.length > 0) {
        const doc = documentPageDetails.find(
          (doc) => doc.DocumentName === docNameRef.current.value
        );
        if (doc) pageCount.current = doc.PageCount;
        if (records.length < pageCount.current) {
          setActionOfAddRule(false);
        } else {
          setActionOfAddRule(true);
        }
      }
    }
    console.log(records);
  };

  const validateRestriction = (restrictionData) => {
    const records = selectionOfRestriction.filter(
      record => record.fileName === restrictionData.fileName && record.id === restrictionData.id
    );
    if (!records.length) return { shouldShowPopup: false };
    const existingPages = records.flatMap(r => r.pages);
    const removedPages = existingPages.filter(page => !restrictionData.pages.includes(page));
    const arePagesChanged = existingPages.length !== restrictionData.pages.length || existingPages.some(page => !restrictionData.pages.includes(page)) || restrictionData.pages.some(page => !existingPages.includes(page));
    const isAllowAccessRequestChanged = records.some(r => r.allowAccessRequest !== restrictionData.allowAccessRequest);
    const hasAccessRequestForRemovedPages = pageLevelAccessRequests?.some(
      request => request.documentId === restrictionData.documentId && request.requestedPages?.some(page => removedPages.includes(page))
    );
    if (isFromManage && enableOptionsBasedOnLevelOne && !isAllowAccessRequestChanged && !restrictionData.allowAccessRequest && arePagesChanged) {
      return {
        shouldShowPopup: true,
        message: selectedLanguage.LstLanguageCodes.UI_EditRuleConfirmationWithAccessRequests
      };
    }
    if (isFromManage && hasAccessRequestForRemovedPages) {
      return {
        shouldShowPopup: true,
        message: selectedLanguage.LstLanguageCodes.UI_EditRuleConfirmationWithAccessRequests
      };
    }
    if (hasAccessRequestForRemovedPages || isAllowAccessRequestChanged || arePagesChanged) {
      return {
        shouldShowPopup: true,
        message: selectedLanguage.LstLanguageCodes.UI_AreYouSureWantToChangeRestrictions
      };
    }
    return {
      shouldShowPopup: false
    };
  };

  const pageRestrictionContent = (
    <div
      className="child-popup"
      id="myModal"
      ref={modalRef}
    //style={{ display: "block", backgroundColor: "#8080801c" }}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg mobile-modal"
        style={{ maxWidth: "800px" }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="d-flex align-items-center text-danger fw-bold mb-0"
              id="staticBackdropLabel">
              {selectedLanguage.LstLanguageCodes.UI_PageRestrictions}
            </h5>
          </div>
          <div
            className="modal-body"
            style={{ maxHeight: "60vh", overflow: "auto" }}>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center">
                <label
                  className="font-w600 control res-w  float-end"
                  htmlFor={selectedDocName}>
                  {selectedLanguage.LstLanguageCodes.UI_DocumentName}:
                </label>
                <select
                  className="SearchFiels ms-3 res-w100 custom-inputBorder"
                  style={{
                    border: "1px solid rgb(213 215 218 / 92%)",
                  }}
                  id={selectedDocName}
                  ref={docNameRef}
                  onChange={onChangeDocNameHandler}>
                  {documentPageDetails.map((documentName) => {
                    return (
                      <option
                        value={documentName.DocumentName}
                        key={documentName.DocumentName}>
                        {documentName.DocumentName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="noteText" style={{ marginTop: "-8px" }}>
              <span className="txtNote">
                {selectedLanguage.LstLanguageCodes.UI_Note}
              </span>
              :{" "}
              <span>
                {
                  selectedLanguage.LstLanguageCodes
                    .UI_IfNochangesAremadeToRestrictions
                }
              </span>
            </div>
            <table
              className="inertable page-restTh"
              style={{ marginTop: "3px" }}>
              <thead className="bg-lightblue">
                <tr>
                  <th className="borderRight" style={{ minWidth: "4rem" }}>
                    {selectedLanguage.LstLanguageCodes.UI_Page}{" "}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_RestrictionType}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_ReadersList}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_RuleNickname}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_RequestAccess}
                  </th>
                  <th className="borderRight">
                    {selectedLanguage.LstLanguageCodes.UI_Actions}
                  </th>
                </tr>
              </thead>
              <tbody>
                {documentReadersSelection.length > 0 &&
                  documentReadersSelection.map((record) => {
                    //return record.pages.map((page, i) => {
                    return (
                      <tr
                        className="borderrow text-wrap-custom"
                        key={record.id}>
                        <td className="pcs w-5p">
                          {record.pages.length > 3 ? (
                            <>
                              <span
                                className="align-items-center flex-wrap textwrap pageTooltip "
                                id={`page_${record.id}`}
                                data-html="true">
                                {`${record.pages.slice(0, 3).join(", ")}...`}
                              </span>
                              <ReactTooltip
                                className="pageTooltipText"
                                anchorId={`page_${record.id}`}
                                clickable
                                noArrow
                              >
                                <table className="tooltip-table timeintractivity-table ">
                                  <div className="d-flex flex-column p-1 tooltip-intial-receipts">
                                    <p className="pageNum-tooltip-text mb-0">
                                      {record.pages.join(", ")}
                                    </p>
                                  </div>
                                </table>
                              </ReactTooltip>
                            </>
                          ) : (
                            <>{record.pages.join(", ")}</>
                          )}
                        </td>
                        <td className="cur w-20p">
                          {record.category === "Selected Readers"
                            ? selectedLanguage.LstLanguageCodes
                              .UI_SelectedReaders
                            : record.category === "Everyone Except Selected Readers"
                              ? selectedLanguage.LstLanguageCodes
                                .UI_EveryOneExceptSelected
                              : selectedLanguage.LstLanguageCodes.UI_NoReaders}
                        </td>
                        <td className="per WrapText ">
                          {(record.category ==
                            "Selected Readers" ||
                            record.category == "Everyone Except Selected Readers") &&
                            record.readers.length > 0
                            ? record.category !=
                            "No Readers" &&
                            record.readers
                              .map((reader) => `${reader}`)
                              .join(", ")
                            : selectedLanguage.LstLanguageCodes
                              .UI_ApplicableToAll}
                        </td>
                        <td className="per WrapText w-20p">
                          {record.ruleNickname}
                        </td>
                        <td>{(record.allowAccessRequest === true) ? selectedLanguage.LstLanguageCodes.UI_Enabled : selectedLanguage.LstLanguageCodes.UI_Disabled}</td>
                        <td className="per w-12p">
                          <div className="d-flex align-items-center justify-content-center">
                            {/* <img
                              // id={`${record.page}_${record.readers
                              //   .map((reader) => `${reader}`)
                              //   .join(",")}_${record.category}_${record.id}_${
                              //   record.ruleNickname
                              // }`}
                              id={record.id}
                              src={EditIcon}
                              className="me-2"
                              alt="Edit"
                              style={{ cursor: "pointer", width: "20px" }}
                              title={selectedLanguage.LstLanguageCodes.UI_Edit}
                              onClick={onEditHandler}
                            /> */}
                            <span
                              id={record.id}
                              onClick={onEditHandler}
                              title={selectedLanguage.LstLanguageCodes.UI_Edit}
                              style={{ fontSize: '19px', cursor: "pointer", width: "27px" }}
                              className="material-icons">
                              edit
                            </span>
                            <img
                              id={record.id}
                              src={"assets/img/icons/bin.png"}
                              className="h-15p"
                              style={{ cursor: "pointer" }}
                              alt="Delete"
                              title={
                                selectedLanguage.LstLanguageCodes.UI_Delete
                              }
                              onClick={onDeleteHandler}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                    // });
                  })}
              </tbody>
            </table>
            {approvedAccessRequests?.length > 0 && (
              <div className="approved-requests">
                <h4>{selectedLanguage.LstLanguageCodes.UI_ApprovedAccessRequests}</h4>
                <table
                  className="inertable page-restTh"
                  style={{ marginTop: "3px" }}>
                  <thead className="bg-lightblue">
                    <tr>
                      <th className="borderRight" style={{ minWidth: "4rem" }}>
                        {selectedLanguage.LstLanguageCodes.UI_Page}{" "}
                      </th>
                      <th className="borderRight">
                        {selectedLanguage.LstLanguageCodes.UI_RestrictionType}
                      </th>
                      <th className="borderRight">
                        {selectedLanguage.LstLanguageCodes.UI_ApprovedReaders}
                      </th>
                      <th className="borderRight">
                        {selectedLanguage.LstLanguageCodes.UI_RuleNickname}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvedAccessRequests.length > 0 &&
                      approvedAccessRequests.map((record) => {
                        //return record.pages.map((page, i) => {
                        return (
                          <tr
                            className="borderrow text-wrap-custom"
                            key={record.id}>
                            <td className="pcs w-5p">
                              {(record.approvedPages)?.sort((a, b) => a - b)?.length > 3 ? (
                                <>
                                  <span
                                    className="align-items-center flex-wrap textwrap pageTooltip "
                                    id={`page_${record.id}`}
                                    data-html="true">
                                    {`${record.approvedPages.slice(0, 3).join(", ")}...`}
                                  </span>
                                  <ReactTooltip
                                    className="pageTooltipText"
                                    anchorId={`page_${record.id}`}
                                    clickable
                                    noArrow
                                  >
                                    <table className="tooltip-table timeintractivity-table ">
                                      <div className="d-flex flex-column p-1 tooltip-intial-receipts">
                                        <p className="pageNum-tooltip-text mb-0">
                                          {record.approvedPages.join(", ")}
                                        </p>
                                      </div>
                                    </table>
                                  </ReactTooltip>
                                </>
                              ) : (
                                <>{record.approvedPages.join(", ")}</>
                              )}
                            </td>
                            <td className="cur w-20p">
                              {record.category === "Selected Readers"
                                ? selectedLanguage.LstLanguageCodes
                                  .UI_SelectedReaders
                                : record.category === "Everyone Except Selected Readers"
                                  ? selectedLanguage.LstLanguageCodes
                                    .UI_EveryOneExceptSelected
                                  : selectedLanguage.LstLanguageCodes.UI_NoReaders}
                            </td>
                            <td className="per WrapText remail-text-ellipsis"
                              title={record.readerEmail}>
                              {record.readerEmail}
                            </td>
                            <td className="per WrapText w-20p">
                              {record.ruleNickname}
                            </td>
                          </tr>
                        );
                        // });
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="modal-footer border-0 pt-1 pb-3 justify-content-between">
            <div>
              <button
                type="button"
                className={`btn btn-outline-success px-2 mt-2 add-rule truncate ${actionOfAddRule ? "disabled" : ""
                  }`}
                data-bs-target="#exampleModalToggle2"
                data-bs-toggle="modal"
                data-bs-dismiss="modal"
                title={selectedLanguage.LstLanguageCodes.UI_AddRestriction}
                disabled={actionOfAddRule}
                onClick={onAddRuleHandler}>
                <span
                  className="material-icons me-2 font-20"
                  style={{ verticalAlign: "bottom" }}>
                  add_circle_outline{" "}
                </span>
                {selectedLanguage.LstLanguageCodes.UI_AddRestriction}
              </button>
            </div>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                data-bs-dismiss="modal"
                onClick={handleCancel}>
                {selectedLanguage.LstLanguageCodes.UI_Cancel}
              </button>
              <button
                type="button"
                className="btn btn-primary px-2 ms-1 w-140p truncate"
                data-bs-dismiss="modal"
                onClick={handleSave}>
                {isFromManage ? selectedLanguage.LstLanguageCodes.UI_SaveFinish : selectedLanguage.LstLanguageCodes.UI_Finish}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <>
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className={alertClass}></Alert>
      <ModalPopUp className="child-popup" ref={warningModal}></ModalPopUp>
      {isPageLevelRestrictionSelected ? (
        createPortal(
          <>
            {isPageLevelRestrictionSelected && !addRule && (
              <>{pageRestrictionContent}</>
            )}
            {isPageLevelRestrictionSelected && addRule && (
              <CreateEditRestrictions
                docPages={pageCount.current}
                fileName={docName.current}
                documentId={documentId.current}
                readers={readers}
                totalReaders={readers}
                editRestrictionDetails={changeSelectionOfRestriction}
                prevSelectedPages={selectedPages}
                pagesToBeDisabledAnotherRestrictions={
                  pagesToBeDisabledAnotherRestrictions
                }
                isEdit={isEdit}
                onCancel={cancelRestrictions}
                onSave={saveRestrictions}
                addReaderToField={handleAddNewReaders}
                ReceipientLists={ReceipientData.current}
                addRule={addRule}
                enableOptionsBasedOnLevelOne={enableOptionsBasedOnLevelOne}
                isFromManage={isFromManage}
                onValidateRestriction={validateRestriction}
                pageLevelAccessRequests={pageLevelAccessRequests}
              />
            )}
          </>,
          document.getElementById("modal-popup")
        )
      ) : (
        <></>
      )}
    </>
  );
});

export default PageRestrictions;
